import classNames from 'classnames/bind';
import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import styles from './TopBar.module.scss';

import AccountCircle from '@/components/ui/AccountCircle';
import Select from '@/components/ui/kit/Select';

const cx = classNames.bind(styles);

const TopBar = ({ children }) => {
  const location = useLocation();

  const key = useMemo(() => {
    return location.pathname.split('/')[1];
  }, [location]);

  const title = useMemo(() => {
    if (key === 'control-center') {
      return 'Control Center';
    } else if (key === 'mission-hub') {
      return 'Mission Hub';
    } else if (key === 'video-manager') {
      return 'Video Manager';
    } else if (key === 'flight-review') {
      return 'Flight Review';
    }
  }, [key]);

  const isShowSelect = useMemo(() => {
    return ['control-center', 'mission-hub', 'video-manager', 'flight-review'].includes(key);
  }, [key]);

  const handleChange = (e) => {
    switch (e.target.value) {
      case 'control-center':
      case 'mission-hub':
      case 'video-manager':
      case 'flight-review':
        window.open(`/${e.target.value}`);
        break;

      case 'g-viewer':
        window.open('https://gimcheon.smatii.com/');
        break;

      default:
        break;
    }
  };

  return (
    <div className={cx('container')}>
      <div className={cx('left')}>
        <img src={require('@/assets/images/logo.png')} alt="M1UCS" />
        <div className={cx('wordmark')}>
          <div className={cx('app')}>M1UCS</div>
          <div className={cx('title')}>{title}</div>
        </div>
      </div>
      <div className={cx('center')}>{children}</div>
      <div className={cx('right')}>
        {isShowSelect && (
          <Select value={key} onChange={handleChange} className={cx('select')}>
            <option value="control-center">Control Center</option>
            <option value="mission-hub">Mission Hub</option>
            <option value="video-manager">Video Manager</option>
            <option value="flight-review">Flight Review</option>
            {process.env.REACT_APP_USE_GVIEWER_LINK === 'true' && <option value="g-viewer">G-Viewer</option>}
          </Select>
        )}
        <AccountCircle />
      </div>
    </div>
  );
};

export default TopBar;
